import styled from 'styled-components';
import { Title } from '@lux/title';
import { BackgroundColor, FunctionColor, Spacer } from '@lux/tokens';

import {
    Screen,
    screenBiggerThan,
    screenSmallerThan,
} from '@client/styles/styled-components/breakpoints';

export const CrossCampaignContainer = styled.div`
    background-color: ${FunctionColor.function0};
    padding: ${Spacer.S} 0;
    margin-bottom: 3%;
`;

export const StyledTitle = styled(Title)`
    margin: 0 0 12px 16px;
`;

export const Container = styled.div`
    display: flex;
    overflow: scroll;

    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

export const Wrapper = styled.div`
    display: block;
    text-align: center;
    margin-right: 8px;

    :first-child {
        margin-left: 16px;
    }
`;

export const StyledImageWrapper = styled.div`
    margin-bottom: 4px;
`;

export const StyledImage = styled.img`
    width: 70px;
    height: 70px;
    border-radius: 50%;
`;

export const EntryPointWrapper = styled.div`
    display: flex;
    flex-direction: column;

    > * {
        padding: ${Spacer.L} ${Spacer.M};
        flex: 1;

        :first-child {
            background-color: ${BackgroundColor.soft};
            position: relative;
        }

        ${screenBiggerThan(Screen.mobile)} {
            padding: ${Spacer.L};

            :first-child::before {
                content: '';
                width: 18px;
                height: 18px;
                transform: rotate(45deg);
                position: absolute;
                right: -9px;
                bottom: 50%;
                background-color: ${BackgroundColor.soft};
            }
        }
    }

    ${screenBiggerThan(Screen.mobile)} {
        gap: 32px;
        flex-direction: row;
        margin-bottom: ${Spacer.L};
        background-color: ${FunctionColor.function0};
    }
`;

export const HeadingWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const LevelOneCategorySelectionWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));
    gap: ${Spacer.L};
    justify-items: center;
    align-items: center;
    padding-left: ${Spacer.XS};

    ${screenSmallerThan(Screen.smallTablet)} {
        > * {
            :first-child {
                position: relative;
            }

            :first-child::before {
                content: '';
                width: 18px;
                height: 18px;
                transform: rotate(45deg);
                position: absolute;
                left: calc(50% - 9px); /* Center it, minus half the width */
                top: -41px; /* Spacer.L (32) + half the height (18 / 2) = 41*/
                background-color: ${BackgroundColor.soft};
                z-index: 1;
            }
        }
    }
`;

export const LevelOneCategory = styled.div`
    width: 64px;
    text-align: center;
`;

export const LevelOneCategoryImage = styled.img`
    width: 64px;
    height: 64px;
    border-radius: 50%;
    cursor: pointer;
    margin-bottom: ${Spacer.XS};
`;
